// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    createAction: {
        id: 'my-actions.createAction',
        defaultMessage: 'Create new action'
    },
    numberAction: {
        id: 'my-actions.numberAction',
        defaultMessage: `{amount, plural,
			one {Action:}
			other {Actions:}
		}`
    },
    enabledAction: {
        id: 'my-actions.enabledAction',
        defaultMessage: 'Enabled'
    },
    disabledAction: {
        id: 'my-actions.disabledAction',
        defaultMessage: 'Disabled'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/intl.js